<div class="sign-up-shop-container" [formGroup]="form">
  <div class="content">
    <div class="personal-data">
      <div class="headline">{{ 'signUp.personalData' | translate }}</div>
      <kion-select
        [options]="titleOptions"
        id="select-salutation"
        controlName="salutation"
        [invalid]="salutationField.invalid && (salutationField.dirty || salutationField.touched)"
        [label]="'forms.address.salutation.label' | translate"
        [placeHolder]="'forms.address.salutation.placeHolder' | translate"
        [form]="form" >
        <ng-container *ngIf="salutationField.invalid && (salutationField.dirty || salutationField.touched)">
          <p class="error" *ngIf="salutationField.errors.required">
            {{ 'forms.required' | translate }}
          </p>
        </ng-container>
      </kion-select>
      <div class="disabledInput">
        <div class="label">{{ 'forms.address.firstName.label' | translate }}</div>
        <div class="name">{{ firstName }}</div>
      </div>
      <div class="disabledInput">
        <div class="label">{{ 'forms.address.lastName.label' | translate }}</div>
        <div class="name">{{ lastName }}</div>
      </div>
      <div class="disabledInput">
        <div class="label">{{ 'forms.address.email.label' | translate }}</div>
        <div class="name">{{ email }}</div>
      </div>
      <kion-input
        id="phone-input"
        controlName="phone"
        [invalid]="phoneField.invalid && (phoneField.dirty || phoneField.touched)"
        [label]="'forms.address.phone.label' | translate"
        [placeHolder]="'forms.address.phone.placeHolder' | translate"
        [form]="form" >
        <ng-container *ngIf="phoneField.invalid && (phoneField.dirty || phoneField.touched)">
          <ng-container *ngIf="phoneField?.errors as error">
            <p class="error" *ngIf="error.required">
              {{ 'forms.required' | translate }}
            </p>
            <p class="error" *ngIf="error.minlength">
              {{ 'forms.minLength' | translate }}
            </p>
            <p class="error" *ngIf="error.maxlength">
              {{ 'forms.maxLength' | translate }}
            </p>
          </ng-container>
        </ng-container>
      </kion-input>
      <kion-input
        id="mobile-input"
        controlName="mobile"
        [invalid]="mobileField?.invalid && (mobileField?.dirty || mobileField?.touched)"
        [label]="'forms.address.mobile.label' | translate"
        [placeHolder]="'forms.address.mobile.placeHolder' | translate"
        [form]="form" >
        <ng-container *ngIf="mobileField?.invalid && (mobileField?.dirty || mobileField?.touched)">
          <p class="error" *ngIf="mobileField?.errors?.minlength">
            {{ 'forms.minLength' | translate }}
          </p>
          <p class="error" *ngIf="mobileField?.errors?.maxlength">
            {{ 'forms.maxLength' | translate }}
          </p>
        </ng-container>
      </kion-input>
    </div>
    <div class="company-data">
      <div class="headline">
        {{ 'signUp.companyData' | translate }}
        <div class="extra">
          {{ 'forms.mandatory.note' | translate }}
        </div>
      </div>
      <kion-input
        id="company-input"
        controlName="company"
        [invalid]="companyField.invalid && (companyField.dirty || companyField.touched)"
        [label]="'forms.address.company.label' | translate"
        [placeHolder]="'forms.address.company.placeHolder' | translate"
        [form]="form" >
        <ng-container *ngIf="companyField.invalid && (companyField.dirty || companyField.touched)">
          <p class="error" *ngIf="companyField.errors.minlength">
            {{ 'forms.minLength' | translate }}
          </p>
          <p class="error" *ngIf="companyField.errors.maxlength">
            {{ 'forms.maxLength' | translate }}
          </p>
        </ng-container>
      </kion-input>
      <kion-input
        id="vat-input"
        controlName="vatId"
        [invalid]="vatIdField.invalid && (vatIdField.dirty || vatIdField.touched)"
        [label]="'forms.address.vatId.label' | translate"
        [placeHolder]="'forms.address.vatId.placeHolder' | translate"
        [form]="form" >
      </kion-input>
      <kion-input
        id="lmhCustomerNumber-input"
        controlName="customerNumber"
        [invalid]="customerNumberField?.invalid && (customerNumberField?.dirty || customerNumberField?.touched)"
        [label]="'forms.address.customerNumber.label' | translate"
        [placeHolder]="'forms.address.customerNumber.placeHolder' | translate"
        [form]="form" >
        <div class="description"> {{ 'forms.address.customerNumber.description' | translate }} </div>
      </kion-input>
      <kion-input
        id="address-input"
        controlName="address"
        [invalid]="addressField.invalid && (addressField.dirty || addressField.touched)"
        [label]="'forms.address.address.label' | translate"
        [placeHolder]="'forms.address.address.placeHolder' | translate"
        [form]="form" >
        <ng-container *ngIf="addressField.invalid && (addressField.dirty || addressField.touched)">
          <p class="error" *ngIf="addressField.errors.required">
            {{ 'forms.required' | translate }}
          </p>
          <p class="error" *ngIf="addressField.errors.minlength">
            {{ 'forms.minLength' | translate }}
          </p>
          <p class="error" *ngIf="addressField.errors.maxlength">
            {{ 'forms.maxLength' | translate }}
          </p>
        </ng-container>
      </kion-input>
      <kion-input
        id="addressAdditional-input"
        controlName="additionalAddress"
        [invalid]="additionalAddressField.invalid && (additionalAddressField.dirty || additionalAddressField.touched)"
        [label]="'forms.address.additionalAddress.label' | translate"
        [placeHolder]="'forms.address.additionalAddress.placeHolder' | translate"
        [form]="form" >
        <ng-container *ngIf="additionalAddressField.invalid && (additionalAddressField.dirty || additionalAddressField.touched)">
          <p class="error" *ngIf="additionalAddressField.errors.minlength">
            {{ 'forms.minLength' | translate }}
          </p>
          <p class="error" *ngIf="additionalAddressField.errors.maxlength">
            {{ 'forms.maxLength' | translate }}
          </p>
        </ng-container>
      </kion-input>
      <kion-input
        id="zipCode-input"
        controlName="zipCode"
        [invalid]="zipCodeField?.invalid && (zipCodeField?.dirty || zipCodeField?.touched)"
        [label]="'forms.address.zipCode.label' | translate"
        [placeHolder]="'forms.address.zipCode.placeHolder' | translate"
        [form]="form" >
        <ng-container *ngIf="zipCodeField?.invalid && (zipCodeField?.dirty || zipCodeField?.touched)">
          <p class="error" *ngIf="zipCodeField?.errors?.required">
            {{ 'forms.required' | translate }}
          </p>
          <p class="error" *ngIf="zipCodeField?.errors?.minlength">
            {{ 'forms.minLength' | translate }}
          </p>
          <p class="error" *ngIf="zipCodeField?.errors?.maxlength">
            {{ 'forms.maxLength' | translate }}
          </p>
        </ng-container>
      </kion-input>
      <kion-input
        id="city-input"
        controlName="city"
        [invalid]="cityField.invalid && (cityField.dirty || cityField.touched)"
        [label]="'forms.address.city.label' | translate"
        [placeHolder]="'forms.address.city.placeHolder' | translate"
        [form]="form" >
        <ng-container *ngIf="cityField.invalid && (cityField.dirty || cityField.touched)">
          <p class="error" *ngIf="cityField.errors.required">
            {{ 'forms.required' | translate }}
          </p>
          <p class="error" *ngIf="cityField.errors.minlength">
            {{ 'forms.minLength' | translate }}
          </p>
          <p class="error" *ngIf="cityField.errors.maxlength">
            {{ 'forms.maxLength' | translate }}
          </p>
        </ng-container>
      </kion-input>
      <div class="disabledInput">
        <div class="label">{{ 'forms.address.country.label' | translate }}</div>
        <div class="name">{{ 'forms.address.country.isoCode.' + isoCode | translate }}</div>
      </div>
    </div>
  </div>
</div>
